import * as Phaser from "phaser-ce"
import { colorNum } from "../utils/ColorUtils"
import { Scale } from "../utils/Scale"
import { GenericAssets } from "./GenericAssets"

export class ProjectorSprite extends Phaser.Sprite {

    projectorMask: Phaser.Graphics

    constructor(game: Phaser.Game, x: number, y: number, defaultScale: number) {
        super(game, x, y, GenericAssets.PROJECTOR)

        game.add.existing(this)
        Scale.scaleSprite(this, defaultScale)

        const projPadX = defaultScale * 0.1149
        const projPadY = defaultScale * 0.135
        this.projectorMask = this.game.add.graphics(x + this.width * projPadX, y + this.height * projPadY)
        this.projectorMask.beginFill(colorNum.white)
        this.projectorMask.drawRect(0, 0, this.width * (1 - projPadX * 2), this.height * (1 - projPadY * 1.88))
    }
}
